import Chip from "@material-ui/core/Chip";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import LockSharpIcon from "@material-ui/icons/LockSharp";
import React from "react";
import {useTranslation} from "react-i18next";
import {Remove} from "@material-ui/icons";
import {ChipBackgroundColors, ChipTextColors} from "../../../../layout/_constants";

export const SingleSubscriptionExpiresIn: React.FC<{subscription: any}> = (props): JSX.Element => {
    const {t} = useTranslation();
    const {subscription} = props;

    switch (subscription.source) {
        case 'OrganizationUnit':
            return <span>{subscription.expirationDate}</span>;
        case 'Organization':
            return <Remove/>;
        case 'Other':
            return <LockSharpIcon/>;
        default:
            return (<span>----</span>);
    }
};
